<template>
  <div class="innerBody">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>打卡任务管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="pageparm" class="user-search">
      <el-form-item label="搜索：">
        <el-select
          size="small"
          v-model="pageparm.status"
          placeholder="请选择任务状态"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button
          size="small"
          type="primary"
          icon="el-icon-search"
          @click="search"
          >搜索</el-button
        >
        <el-button
          size="small"
          type="primary"
          icon="el-icon-plus"
          @click="handleEdit()"
          >添加</el-button
        >
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table
      size="small"
      :data="listData"
      highlight-current-row
      v-loading="loading"
      border
      element-loading-text="拼命加载中"
      style="width: 100%"
    >
      <el-table-column prop="id" label="任务ID"> </el-table-column>
      <el-table-column prop="image" label="任务图片">
        <template slot-scope="scope">
          <img
            :src="$store.state.fileBaseUrl + scope.row.image"
            alt=""
            style="width: 100px; height: 100px"
          />
        </template>
      </el-table-column>

      <el-table-column prop="title" label="任务标题"> </el-table-column>
      <el-table-column prop="endTime" label="截止日期"> </el-table-column>
      <el-table-column prop="rules" label="任务规则"> </el-table-column>
      <el-table-column prop="pointsReward" label="积分奖励"> </el-table-column>

      <el-table-column align="center" label="操作" width="300">
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="mini"
            @click="handleEdit(scope.$index, scope.row)"
            >编辑</el-button
          >

          <el-button
            type="primary"
            size="mini"
            @click="showDrawLog(scope.row)"

            v-if="scope.row.prizeGoods.length != 0 && scope.row.status == 0"

            >抽奖</el-button
          >
          <!-- <el-button
            size="mini"
            type="danger"
            @click="deleteUser(scope.$index, scope.row)"
            >删除</el-button
          > -->
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <div class="pagtion">
      <Pagination
        v-bind:child-msg="pageparm"
        @callFather="callFather"
      ></Pagination>
    </div>

    <!-- 编辑界面 -->
    <el-dialog
      :title="title"
      :visible.sync="editFormVisible"
      width="50%"
      @click="closeDialog"
    >
      <el-form
        label-width="120px"
        :model="editForm"
        :rules="rules"
        ref="editForm"
      >
        <div class="box">
          <div style="width: 50%; flex-shrink: 0">
            <el-form-item label="任务标题" prop="title">
              <el-input
                size="small"
                v-model="editForm.title"
                auto-complete="off"
                placeholder="请输入打卡任务标题"
              ></el-input>
            </el-form-item>

            <el-form-item label="任务图片" prop="image">
              <upImg v-model="editForm.image"></upImg>
            </el-form-item>

            <el-form-item label="截止日期" prop="endTime">
              <el-date-picker
                v-model="editForm.endTime"
                type="datetime"
                placeholder="选择日期时间(任务截止)"
                align="right"
                value-format="yyyy-MM-dd HH:mm:ss"
                :picker-options="pickerOptions"
              >
              </el-date-picker>
            </el-form-item>
          </div>
          <div style="width: 50%; flex-shrink: 0">
            <el-form-item label="任务规则" prop="rules">
              <el-input
                size="small"
                v-model="editForm.rules"
                auto-complete="off"
                placeholder="请输入打卡任务规则(简短)"
              ></el-input>
            </el-form-item>

            <el-form-item label="积分奖励" prop="pointsReward">
              <el-input
                size="small"
                type="number"
                v-model="editForm.pointsReward"
                auto-complete="off"
                placeholder="请输入打卡任务积分奖励(完成打卡奖励积分)"
                ><template slot="append">分</template></el-input
              >
            </el-form-item>

            <el-form-item label="任务状态" prop="status">
              <el-radio-group v-model="editForm.status">
                <el-radio :label="1">进行中</el-radio>
                <el-radio :label="0">已结束</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item label="抽奖礼物" prop="content"> </el-form-item>
            <div style="padding-left: 50px; min-height: 200px">
              <div class="giftLine">
                <div
                  class="gitfItem"
                  v-for="(item, index) in editForm.prizeGoodsIds"
                  :key="index"
                >
                  <div class="left">{{ item.name }}</div>
                  <div class="right">{{ item.pointsPrice }}积分</div>
                </div>
              </div>

              <el-button type="primary" @click="addGift(editForm.prizeGoodsIds)"
                >选择商品</el-button
              >
            </div>
            <!-- <el-form-item label="抽奖礼物" prop="prizeGoodsIds">
              <el-select v-model="editForm.prizeGoodsIds" placeholder="请选择">
    <el-option
      v-for="item in goodsList"
      :key="item.value"
      :label="item.name"
      :value="item.value">
      <span style="float: left">{{ item.label }}</span>
      <span style="float: right; color: #8492a6; font-size: 13px">{{ item.value }}</span>
    </el-option>
  </el-select>
            </el-form-item> -->
          </div>
        </div>

        <el-form-item label="任务说明" prop="content"> </el-form-item>
        <div style="padding-left: 40px; min-height: 200px">
          <editor v-model="editForm.content"> </editor>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button
          size="small"
          type="primary"
          :loading="loading"
          class="title"
          @click="submitForm('editForm')"
          >保存</el-button
        >
      </div>
    </el-dialog>

    <gift ref="giftLog" @confirm="selectGift"></gift>
    <draw ref="drawLog" @close="search"></draw>
  </div>
</template>

<script>
import Pagination from "../../components/Pagination";
import upImg from "../../components/upImg.vue";
import editor from "../../components/editor.vue";
import gift from "./gift.vue";
import draw from "./draw.vue";
export default {
  data() {
    return {
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: "添加",
      editForm: {
        id: "",
        title: "",
        image: "",
        endTime: "",
        rules: "",
        pointsReward: "",
        status: 1,
        prizeGoodsIds: [],
        content: "",
      },
      // rules表单验证
      rules: {
        title: [
          { required: true, message: "请输入打卡任务标题", trigger: "blur" },
        ],
        image: [
          { required: true, message: "请上传打卡任务图片", trigger: "blur" },
        ],
        endTime: [
          { required: true, message: "请选择任务截止日期", trigger: "blur" },
        ],
        rules: [
          { required: true, message: "请输入打卡任务规则", trigger: "blur" },
        ],
        pointsReward: [
          {
            required: true,
            message: "请输入打卡任务积分奖励",
            trigger: "blur",
          },
        ],
      },
      pickerOptions: {
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              picker.$emit("pick", new Date());
            },
          },
          {
            text: "明天",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24);
              picker.$emit("pick", date);
            },
          },
          {
            text: "三天后",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 3);
              picker.$emit("pick", date);
            },
          },
        ],
      },
      listData: [],
      pageparm: {
        pageNum: 1,
        pageSize: 10,
        total: 10,
        status: "",
      },
      options: [
        {
          value: "",
          label: "全部",
        },
        {
          value: "1",
          label: "进行中",
        },
        {
          value: "0",
          label: "已结束",
        },
      ],
      goodsList: [],
    };
  },
  // 注册组件
  components: {
    Pagination,
    upImg,
    editor,
    gift,
    draw,
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.pageparm);
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    showDrawLog(item){
      this.$refs.drawLog.init(item)
    },
    selectGift(e) {
      console.log(e);
      this.editForm.prizeGoodsIds = e;
    },
    addGift(arr) {
      this.$refs.giftLog.init(arr);
    },
    getdata(parameter) {
      this.loading = true;
      this.$request
        .getTasks(parameter)
        .then((res) => {
          this.loading = false;
          console.log(res.data);
          this.listData = res.data.list;
          // // 分页赋值
          this.pageparm.pageNum = res.data.pageNum;
          this.pageparm.pageSize = res.data.pageSize;
          this.pageparm.total = res.data.total;
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    // 分页插件事件
    callFather(parm) {
      this.pageparm.pageNum = parm.currentPage;
      this.pageparm.pageSize = parm.pageSize;
      this.getdata(this.pageparm);
    },
    // 搜索事件
    search() {
      this.getdata(this.pageparm);
    },
    //显示编辑界面
    handleEdit: function (index, row) {
      this.editFormVisible = true;
      if (row != undefined && row != "undefined") {
        this.title = "修改";
        this.editForm.id = row.id;
        this.editForm.title = row.title;
        this.editForm.image = row.image;
        this.editForm.endTime = row.endTime;
        this.editForm.rules = row.rules;
        this.editForm.pointsReward = row.pointsReward;
        this.editForm.status = row.status;
        this.editForm.prizeGoodsIds = row.prizeGoods;
        this.editForm.content = row.content;
      } else {
        delete this.editForm.id;
        this.title = "添加";
        this.editForm.title = "";
        this.editForm.image = "";
        this.editForm.endTime = "";
        this.editForm.rules = "";
        this.editForm.pointsReward = "";
        this.editForm.status = 1;
        this.editForm.prizeGoodsIds = [];
        this.editForm.content = "";
      }
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate((valid) => {
        if (valid) {
          if (this.editForm.prizeGoodsIds.length != 0) {
            let arr = this.editForm.prizeGoodsIds;
            this.editForm.prizeGoodsIds = arr.map((item) => {
              return item.id;
            });
            console.log(this.editForm.prizeGoodsIds);
          }

          this.$request
            .addTasks(this.editForm)
            .then((res) => {
              this.editFormVisible = false;
              this.loading = false;
              this.getdata(this.pageparm);
              this.$message({
                type: "success",
                message: "保存成功！",
              });
            })
            .catch((err) => {
              this.editFormVisible = false;
              this.loading = false;
            });
        } else {
          return false;
        }
      });
    },
    // 删除公司
    deleteUser(index, row) {
      this.$confirm("确定要删除吗?", "信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$request
            .deleteBanner({ id: row.id })
            .then((res) => {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
              this.getdata(this.pageparm);
            })
            .catch((err) => {
              this.loading = false;
              this.$message.error("删除失败，请稍后再试！");
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormVisible = false;
    },
  },
};
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
.box {
  display: flex;
}
.giftLine {
  width: 100%;
}
.gitfItem {
  display: flex;
  align-items: center;

  margin-bottom: 15px;
}
.left {
  font-size: 22px;
  color: #000000;
  margin-right: 15px;
}

.left {
  font-size: 14px;
  color: #000000;
  margin-right: 10px;
}
</style>





// WEBPACK FOOTER //
// src/views/tasks/tasks.vue